import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResult } from './base.service';
import { AdministracionObjetivos } from '../models/administracion-objetivos';
import { DashboardKPI, DashBoardModel } from '../models/estadosGroup';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  myAppUrl: string;

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.myAppUrl = baseUrl;
  }

  getEstadosGroup(): Observable<DashBoardModel> {
    return this.http.get<DashBoardModel>(this.myAppUrl + 'api/dashboard/TasacionesGroup');
  }

  getIncidenciasData(): Observable<DashboardKPI[]> {
    return this.http.get<DashboardKPI[]>(this.myAppUrl + 'api/dashboard/IncidenciasData');
  }

  getTecnicoData():Observable<DashboardKPI> {
    return this.http.get<DashboardKPI>(this.myAppUrl + 'api/dashboard/TecnicoData');
  }
  getValidadorData():Observable<DashboardKPI[]> {
    return this.http.get<DashboardKPI[]>(this.myAppUrl + 'api/dashboard/ValidadorData');
  }

  getObjetivos(year: number, oficinaID: number ): Observable<ApiResult<AdministracionObjetivos>> {

    const url = this.myAppUrl + 'api/dashboard/ObjetivosData';

    let params = new HttpParams()
      .set('year', year.toString())
      .set('idOficina', oficinaID.toString())

    return this.http.get<ApiResult<AdministracionObjetivos>>(url, { params });
  }

  getOficinasFacturacion() {

    var resultado = this.http.get(this.myAppUrl + 'api/oficinaFacturacion/getDropDownList');
    return resultado;
  }
}
